import { Disclosure } from '@headlessui/react';
import { Fragment, useEffect } from 'react';
import { useEssayFilterStore } from '../../../stores/essayFilterStore';
import { useEssayCoreStore } from '../../../../../core/stores/essayCoreStore';
import { useGetThemeAxis } from '../../../../../core/hooks/useGetThemeAxis';
import { Modal } from '../../../../../core/components/templates/Modal';
import { Button } from '../../../../../core/components/atoms/Button';
import { Icon } from '../../../../../core/components/atoms/Icon';
import { Typography } from '../../../../../core/components/molecules/Typography';
import InnerCheckbox from '../../../../Disciplines/components/exercises/components/innerCheckbox';

interface IFilterEssay {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export default function FilterEssay({
  isOpen,
  onClose,
  onSubmit,
}: IFilterEssay) {
  const { status, banca, axis, setStatus, setBanca, setAxis } =
    useEssayFilterStore();

  const { mutate } = useGetThemeAxis();
  const { themeAxis } = useEssayCoreStore();

  useEffect(() => {
    mutate();
  }, []);

  const handleStatus = (tipo: string) => {
    const aux = [...status];

    if (aux.includes(tipo)) {
      const idx = aux.indexOf(tipo);
      aux.splice(idx, 1);

      setStatus(aux);
    } else {
      aux.push(tipo);

      setStatus(aux);
    }
  };

  const handleBanca = (correcao: number) => {
    const aux = [...banca];

    if (aux.includes(correcao)) {
      const idx = aux.indexOf(correcao);
      aux.splice(idx, 1);

      setBanca(aux);
    } else {
      aux.push(correcao);

      setBanca(aux);
    }
  };

  const handleAxis = (theme: string) => {
    const aux = [...axis];

    if (aux.includes(theme)) {
      const idx = aux.indexOf(theme);
      aux.splice(idx, 1);

      setAxis(aux);
    } else {
      aux.push(theme);

      setAxis(aux);
    }
  };

  const reset = () => {
    setStatus([]);
    setBanca([]);
    setAxis([]);

    onSubmit();
  };

  return (
    <Modal
      position={window.innerWidth < 769 ? 'bottom' : 'top-right'}
      size='md'
      isOpen={isOpen}
      onClose={() => onClose()}
      className='xs:h-[75vh] xs:w-full lg:h-full lg:w-[35%]'
      title='Filtrar redações'
    >
      <div
        id='filterContainer'
        className='flex w-full flex-col gap-md overflow-x-auto px-2 py-2 xs:h-[45vh] lg:h-[75vh]'
      >
        <Disclosure>
          {({ open }) => (
            <Fragment>
              <Disclosure.Button className='flex w-full justify-between text-left'>
                <Typography size='h4' type='title' className='text-left'>
                  Status da redação
                </Typography>
                <Icon
                  Icon='expand_more'
                  type='material'
                  className={`${open ? 'rotate-180 transform' : ''} h-5 w-5 text-mono-color-black`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className='mt-5 flex w-full flex-col gap-xl pb-3 pl-4'>
                <InnerCheckbox
                  onChange={() => handleStatus('sent')}
                  label='Aguardando correção'
                  checked={status.indexOf('sent') >= 0}
                  id='status-aguardando'
                  value='sent'
                />
                <InnerCheckbox
                  onChange={() => handleStatus('corrected')}
                  label='Corrigidas'
                  checked={status.indexOf('corrected') >= 0}
                  id='status-corrected'
                  value='corrected'
                />
                <InnerCheckbox
                  onChange={() => handleStatus('writing')}
                  label='Salvas (Não enviadas)'
                  checked={status.indexOf('writing') >= 0}
                  id='status-wrinting'
                  value='writing'
                />
              </Disclosure.Panel>
            </Fragment>
          )}
        </Disclosure>
        <Disclosure>
          {({ open }) => (
            <Fragment>
              <Disclosure.Button className='flex w-full justify-between text-left'>
                <Typography size='h4' type='title' className='text-left'>
                  Bancas de correção
                </Typography>
                <Icon
                  Icon='expand_more'
                  type='material'
                  className={`${open ? 'rotate-180 transform' : ''} h-5 w-5 text-mono-color-black`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className='mt-5 flex w-full flex-col gap-xl pb-3 pl-4'>
                <InnerCheckbox
                  onChange={() => handleBanca(2)}
                  label='ENEM'
                  checked={banca.indexOf(2) >= 0}
                  id='correction-enem'
                  value='enem'
                />
                <InnerCheckbox
                  onChange={() => handleBanca(3)}
                  label='FUVEST'
                  checked={banca.indexOf(3) >= 0}
                  id='correction-fuvest'
                  value='fuvest'
                />
                <InnerCheckbox
                  onChange={() => handleBanca(5)}
                  label='UNICAMP'
                  checked={banca.indexOf(5) >= 0}
                  id='correction-unicamp'
                  value='unicamp'
                />
                <InnerCheckbox
                  onChange={() => handleBanca(4)}
                  label='UNESP'
                  checked={banca.indexOf(4) >= 0}
                  id='correction-unesp'
                  value='unesp'
                />
                <InnerCheckbox
                  onChange={() => handleBanca(6)}
                  label='UFPR'
                  checked={banca.indexOf(6) >= 0}
                  id='correction-ufpr'
                  value='ufpr'
                />
                <InnerCheckbox
                  onChange={() => handleBanca(7)}
                  label='GÊNEROS'
                  checked={banca.indexOf(7) >= 0}
                  id='correction-generos'
                  value='generos'
                />
              </Disclosure.Panel>
            </Fragment>
          )}
        </Disclosure>
        <Disclosure>
          {({ open }) => (
            <Fragment>
              <Disclosure.Button className='flex w-full justify-between text-left'>
                <Typography size='h4' type='title' className='text-left'>
                  Eixos temáticos
                </Typography>
                <Icon
                  Icon='expand_more'
                  type='material'
                  className={`${open ? 'rotate-180 transform' : ''} h-5 w-5 text-mono-color-black`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className='mt-5 flex w-full flex-col gap-xl pb-3 pl-4'>
                {themeAxis &&
                  themeAxis.length > 0 &&
                  themeAxis.map((it, i) => (
                    <InnerCheckbox
                      key={i}
                      onChange={() => handleAxis(it.id)}
                      label={it.title}
                      checked={axis.indexOf(it.id) >= 0}
                      id={`themeAxis-essays-${it.slug}`}
                      value={it.id}
                    />
                  ))}
              </Disclosure.Panel>
            </Fragment>
          )}
        </Disclosure>
      </div>
      <div className='fixed bottom-0 left-0 flex w-full flex-row items-center justify-center gap-lg px-4 py-5'>
        <Button
          variant='text'
          LeftIcon='delete'
          iconType='material'
          className='w-1/2'
          full
          onClick={() => reset()}
        >
          Limpar seleção
        </Button>
        <Button className='w-1/2' full onClick={() => onSubmit()}>
          Aplicar filtros
        </Button>
      </div>
    </Modal>
  );
}
